
export interface IDbConfigResponse {
    patentCountries: PatentCountriesResponse;
}

export interface PatentCountriesResponse {
    major: ISelectDataResponse[];
    others: ISelectDataResponse[];
    ip5: ISelectDataResponse[];
}
export interface ISelectDataResponse {
    id: string | number;
    label: string;
    checked: boolean;
}
export interface PatentDbApi {
    /**
     * 获取专利数据库配置
     */
    getDbConfig(): Promise<IDbConfigResponse>;
}

export const PatentDbApi = Symbol.for('PatentDbApi');
